import { CompanyPageTemplateUiState } from 'api/company-page-template/types';
import { PageType, SourceType, TiptapJson } from 'api/page-template/types';
import { BaseTemplatePage } from '../shared/base-template';
import { defaultContent } from '../utils';

export const CompanyTemplatePageV2 = ({
  templateData,
  onTemplateChange,
  previousTiptapJson,
}: {
  templateData?: CompanyPageTemplateUiState;
  onTemplateChange: (payload: Partial<CompanyPageTemplateUiState>) => void;
  previousTiptapJson?: TiptapJson;
}) => {
  return (
    <BaseTemplatePage<PageType.Company, SourceType.Company>
      pageType={PageType.Company}
      templateData={templateData}
      onTemplateChange={onTemplateChange}
      defaultContent={defaultContent}
      supportFilter={false}
      previousTiptapJson={previousTiptapJson}
    />
  );
};
